import { render, staticRenderFns } from "./ProductKeywordAnalyze.vue?vue&type=template&id=33d04228"
import script from "./ProductKeywordAnalyze.vue?vue&type=script&lang=js"
export * from "./ProductKeywordAnalyze.vue?vue&type=script&lang=js"
import style0 from "./ProductKeywordAnalyze.vue?vue&type=style&index=0&id=33d04228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports